import React from "react";
import { useState, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import FicheEleve from "./FicheEleve";
import { useClasseContext } from "../context/ClasseContext";
import { useUser } from "../context/UserContext";
import { isInPeriode } from "../utils/periode";
import BarreRecherche from "../components/shared/BarreRecherche";
import SelectFiltre from "../components/shared/SelectFiltre";
import useCardTableView from "../hooks/ui/useCardTableView";
import { useEleve } from "../hooks/fetch_api_hook/useEleve";
import * as XLSX from 'xlsx';
import Loading from "../components/general/Loading";
import { useRef } from "react";

import { TableRowEleve } from "../components/VueEleve/Component-Page-Eleve/TableRowEleve";
import { StudentCard } from "../components/VueEleve/Component-Page-Eleve/StudentCard";
import AddElevesToGroup from "../components/VueEleve/AdminEleve/AddElevesToGroup";
import ComposerDemiGroupe from "../components/VueEleve/AdminEleve/ComposerDemiGroupe";
import { estDemiGroupe } from "../utils/groupesDeBesoin";

function Eleve({eleves,handleReload, handleMessagePost, messagePost}) {
    const {idclasse} = useParams();
    const [listEleves, setListEleves] = useState([]);
    const [resultats, setResultats] = useState([]);
    const [selectedEleveId, setSelectedEleveId] = useState();
    const {groupNom, classeNom, ActivePeriode} = useClasseContext();
    // Établissement GAR : les élèves se connectent via l'ENT (SSO), jamais par
    // identifiant/mot de passe TanoEd — la génération d'identifiants n'a pas
    // de sens et sèmerait la confusion (deux « comptes » par élève).
    const { etablissementData } = useUser();
    const estGar = !!etablissementData?.is_gar;
    // Toggle cartes/tableau + responsive (logique partagée).
    const { view: currentView, setView: setCurrentView, isMobile } = useCardTableView();
    // State nécessaire pour le filtre par groupe, par résultats par nom-prénom.
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedGroup, setSelectedGroup] = useState('all');
    const [selectedAverage, setSelectedAverage] = useState('all');
    //Manipulation d'affiche lorsque l'on effecture un clic.
    const divRef = useRef(null); // Créer une référence à la div
    // Fiches en LECTURE SEULE (spec GAR §0.7) : ajout, suppression et édition
    // d'identité passent désormais par l'import établissement (wizard).
    const [showGenerate, setShowGenerate] = useState(false);

                // Récupération des groupes uniques
        // Ne se recalcule QUE quand listEleves change
        const uniqueGroups = useMemo(() => {
          return [...new Set(listEleves.map(student => student.groupe_nom).filter(Boolean))];
        }, [listEleves]);

   // 1. Ajouter ces états dans votre composant Eleve (après les autres useState)
const [sortConfig, setSortConfig] = useState({ key: 'nom', direction: 'asc' });

// 2. Ajouter cette fonction de tri (après les autres fonctions)
const handleSort = (key) => {
  let direction = 'asc';
  if (sortConfig.key === key && sortConfig.direction === 'asc') {
    direction = 'desc';
  }
  setSortConfig({ key, direction });
};

  // On mets la liste d'élèves dans l'ordre, on ne garde que les résultats défini par la période.
    useEffect(() => {
  if (eleves && eleves.eleves) {
    // Créez une copie triée de la liste des élèves par nom puis par prénom
    let processedEleves = [...eleves.eleves].sort((a, b) => {
      const nomA = a.nom.toLowerCase();
      const nomB = b.nom.toLowerCase();
      if (nomA < nomB) return -1;
      if (nomA > nomB) return 1;
      // Si les noms sont identiques, comparer par prénom
      const prenomA = a.prenom.toLowerCase();
      const prenomB = b.prenom.toLowerCase();
      if (prenomA < prenomB) return -1;
      if (prenomA > prenomB) return 1;
      return 0;
    });

    // Filtrer les résultats par période active si elle existe
    if (ActivePeriode && ActivePeriode.date_debut && ActivePeriode.date_fin) {
      processedEleves = processedEleves.map(eleve => ({
        ...eleve,
        resultats: eleve.resultats.filter(resultat => isInPeriode(resultat.evalDate, ActivePeriode))
      }));
    }
    
    setListEleves(processedEleves);
  }
}, [eleves, idclasse, ActivePeriode]); // N'oubliez pas d'ajouter ActivePeriode aux dépendances

    useEffect( ()=> {
      const resultatsTemp = {};
      if(listEleves){
        listEleves.forEach( eleve => {
          const {id, nom, prenom, resultats} = eleve;
          const compteur = { rouge: 0 , orange : 0 , yellow : 0, teal:0, vert : 0 , vertplus : 0 , total : 0}; 
          resultats.forEach( (resultat) => {
            // Filtrer par date : ne compter que si le résultat est dans la période active
              if (!isInPeriode(resultat.evalDate, ActivePeriode)) return;
            const {scores} = resultat;
            if(scores===null || scores ===0){
              compteur.total -=1
            }
            else if(scores===1){
              compteur.rouge +=1;
            } else if (scores ===2) {
              compteur.orange +=1;
            } else if(scores === 3){
              compteur.yellow +=1
            } 
            else if(scores===4){
              compteur.teal +=1
            }
            else if (scores === 5){
              compteur.vert +=1
            } else if(scores ===6) {
              compteur.vertplus += 1
            }
            compteur.total +=1 ; 
          });
          resultatsTemp[id+nom+prenom] = compteur;
        });
        setResultats(resultatsTemp);
      }
    }, [listEleves,ActivePeriode])



    const handleRowClick = (item) => {
   
      item ? setSelectedEleveId(item.id) : setSelectedEleveId(null);
    }


    const [showModal, setShowModal] = useState(false);

  const handleClose = (result) => {
    setShowModal(false);
    if (result === 'success') {
     
      // Recharger la liste des élèves, afficher un message de succès, etc.
    }
  };




const handleAddEleveToGroup = (item) => {
  handleAddStateEleve(item)
  handleReload();
}

const handleAddStateEleve = (item) => {
  const newEleve = { ...item, resultats: [] };
  handleMessagePost("Élève correctement ajouté : " + newEleve.nom + " " + newEleve.prenom);

  // Ajouter le nouvel élève à la liste existante sans effacer les autres
  setListEleves(prevListEleve => [...prevListEleve, newEleve]);
}
  
  // Calculer la moyenne d'un eleve.
const calculerMoyenne = (eleve) => {
    // Vérifier que l'élève et ses résultats existent
    if (!eleve || !eleve.resultats || !Array.isArray(eleve.resultats)) {
        return 0; // ou null selon votre préférence
    }

    let totalScore = 0;
    let nombreResultatsValides = 0;
    
    eleve.resultats.forEach(resultat => {
        // Vérifier que scores existe, est un nombre, et n'est pas 0
        if (resultat.scores && typeof resultat.scores === 'number' && resultat.scores !== 0) {
            totalScore += (resultat.scores * 20 / 6);
            nombreResultatsValides++;
        }
    });

    // Si aucun résultat valide
    if (nombreResultatsValides === 0) {
        return 0; // Retourner un nombre pour cohérence
    }

    // Calculer la moyenne et retourner un nombre
    const moyenne = totalScore / nombreResultatsValides;
    
    return Math.round(moyenne * 100) / 100; // Arrondi à 2 décimales mais reste un nombre
}
const getNombreEvaluationsUniques = (classe) => {
  // Vérifier que la classe existe et a des élèves
  if (!classe ||  !Array.isArray(classe)) {
    return 0;
  }

  // Utiliser un Set pour stocker les evalId uniques
  const evaluationsUniques = new Set();

  // Parcourir tous les élèves
  classe.forEach(eleve => {
    // Vérifier que l'élève a des résultats
    if (eleve.resultats && Array.isArray(eleve.resultats)) {
      // Parcourir tous les résultats de l'élève
      eleve.resultats.forEach(resultat => {
        // Ajouter l'evalId au Set (les doublons sont automatiquement ignorés)
        if (resultat.evalId) {
          evaluationsUniques.add(resultat.evalId);
        }
      });
    }
  });
  // Retourner le nombre d'évaluations uniques
  return evaluationsUniques.size;
};
// MÉTHODE  : Moyenne des moyennes chaque élève a le meme poids au lieu de partir sur un poids évaluation.
// Cette méthode calcule la moyenne de chaque élève, puis fait la moyenne de ces moyennes
const getMoyenneClasse = (classe) => {
    let sommeMoyennesEleves = 0;
    let nombreElevesAvecNotes = 0;
    
    classe.forEach(eleve => {
        const moyenneEleve = calculerMoyenne(eleve);
        if (moyenneEleve > 0) { // L'élève a au moins une note
            sommeMoyennesEleves += moyenneEleve;
            nombreElevesAvecNotes++;
        }
    });
    
    if (nombreElevesAvecNotes === 0) return 0;
    
    return Math.round((sommeMoyennesEleves / nombreElevesAvecNotes) * 100) / 100;
};

// Donne le nombre total d'évaluations différentes données pour ces élèves.
const getNbEval = (eleve) => {
  // Créer un objet pour stocker les scores par évaluation
  const evaluations = {};

  // Parcourir les résultats de l'élève
  eleve.resultats.forEach(resultat => {
      const evalId = resultat.evalId;

      // Initialiser l'évaluation si elle n'existe pas encore
      if (!evaluations[evalId]) {
          evaluations[evalId] = [];
      }

      // Ajouter le score à l'évaluation correspondante
      evaluations[evalId].push(resultat.scores);
  });
  // Filtrer les évaluations pour lesquelles tous les scores sont nuls ou vides
  const evaluationsValides = Object.values(evaluations).filter(scores => {
      return scores.some(score => score !== 0 && score !== null && score !== undefined);
  });

  // Retourner le nombre d'évaluations valides
  if (evaluationsValides.length === 0) {
      return "-";
  }
  return evaluationsValides.length;
};

const getPositionIcon = (position) => {
    if (position === 1) return '🥇';
    if (position <= 3) return '🏆';
 
  };

  // RECUPERER LES INITIALS DE L'ELEVE
  const getInitials = (nom, prenom) => {
    if(nom && prenom){
      return (nom[0] + prenom[0]).toUpperCase();}
      else return ''
  };


// A CODER DE FACON OPTIMISER SUR LE BACK-END !!!
const getClassementEleve = (eleve, listeEleves) => {
  // Vérifier les paramètres
  if (!eleve || !listeEleves || !Array.isArray(listeEleves)) {
    return null;
  }
  // Calculer la moyenne de l'élève cible
  const moyenneEleve = calculerMoyenne(eleve);
  // Si l'élève n'a pas de notes, pas de classement
  if (moyenneEleve === 0) {
    return null;
  }
  // Calculer les moyennes de tous les élèves et les stocker
  const elevesAvecMoyennes = listeEleves
    .map(e => ({
      id: e.id,
      moyenne: calculerMoyenne(e)
    }))
    .filter(e => e.moyenne > 0) // Garder seulement ceux qui ont des notes
    .sort((a, b) => b.moyenne - a.moyenne); // Trier par moyenne décroissante

  // Trouver la position de l'élève
  let rang = 1;
  let exAequo = 0;
  
  for (let i = 0; i < elevesAvecMoyennes.length; i++) {
    // Si on trouve notre élève
    if (elevesAvecMoyennes[i].id === eleve.id) {
      return {
        rang: rang,
        total: elevesAvecMoyennes.length,
        moyenne: moyenneEleve,
        exAequo: exAequo > 0 // Indique s'il y a des ex-aequo
      };
    }  
    // Gérer les ex-aequo : si la moyenne suivante est différente
    if (i < elevesAvecMoyennes.length - 1 && 
        elevesAvecMoyennes[i].moyenne > elevesAvecMoyennes[i + 1].moyenne) {
      rang = i + 2; // Le prochain élève aura ce rang
      exAequo = 0;
    } else if (i < elevesAvecMoyennes.length - 1) {
      exAequo++; // Compter les ex-aequo
    }
  }
  // Si on n'a pas trouvé l'élève (ne devrait pas arriver)
  return null;
};
  
  if(eleves && eleves.eleves && eleves.eleves.length === 0 ){
    // Demi-groupe vide (décision prof 2026-09-30) : ses profs le composent
    // eux-mêmes en cochant les élèves de sa classe. Le message d'import reste
    // pour une classe et pour un groupe de besoin.
    if (groupNom && !classeNom && estDemiGroupe(eleves)) {
      return (
        <ComposerDemiGroupe
          groupe={eleves}
          groupeId={idclasse}
          groupNom={groupNom}
          handleReload={handleReload}
          handleMessagePost={handleMessagePost}
        />
      );
    }
    return(
      <div className="bg-white p-4 rounded-lg shadow-md text-left mb-5 h-fit">
      <p className="text-sm sm:text-base lg:text-lg p-2">
        Aucun élève n'a été détecté pour cette classe dans TanoEd.
        <br/> L'import des élèves se fait via l'<span className="font-bold">Import établissement</span> (fichier complet, 5 colonnes), par le délégué d'affectation ou le chef d'établissement.
      </p>
    </div>
    )
  }
  //On créé des fonctions utilitaires pour prendre le nom et prénom GAR pour les filtres (si l'élève est synchronisé.)
const getStudentNom = (student) => {
  const isEleveGAR = student.synchronise_gar && student.eleve_gar;
  return isEleveGAR ? student.eleve_gar_nom : student.nom;
};

const MOYENNE_OPTIONS = [
  { value: 'all', label: 'Toutes moyennes' },
  { value: 'excellent', label: 'Excellence (16-20)' },
  { value: 'tres-bien', label: 'Très bien (14-16)' },
  { value: 'bien', label: 'Bien (12-14)' },
  { value: 'ameliorer', label: 'À améliorer (<12)' },
];

const getStudentPrenom = (student) => {
  const isEleveGAR = student.synchronise_gar && student.eleve_gar;
  return isEleveGAR ? student.eleve_gar_prenom : student.prenom;
};
const filteredStudents = listEleves.filter(student => {
  // Utiliser les fonctions utilitaires pour le filtrage
    const studentNom = getStudentNom(student);
    const studentPrenom = getStudentPrenom(student);
    const matchesSearch = studentNom?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         studentPrenom?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesGroup = selectedGroup === 'all' || (classeNom ? student.groupe_nom === selectedGroup : student.classe_nom === selectedGroup);
    const moyenneEleve = calculerMoyenne(student)
    const matchesAverage = selectedAverage === 'all' || 
                          (selectedAverage === 'excellent' && moyenneEleve >= 16) ||
                          (selectedAverage === 'tres-bien' && moyenneEleve >= 14 && moyenneEleve < 16) ||
                          (selectedAverage === 'bien' && moyenneEleve >= 12 && moyenneEleve < 14) ||
                          (selectedAverage === 'ameliorer' && moyenneEleve < 12);
    
    return matchesSearch && matchesGroup && matchesAverage;
  }).sort((a, b) => {
    if (!sortConfig.key) return 0;
    
    let aValue, bValue;
    
    switch(sortConfig.key) {
      case 'nom':
        aValue = getStudentNom(a).toLowerCase();
        bValue = getStudentNom(b).toLowerCase();
        break;
      case 'prenom':
        aValue = getStudentPrenom(a).toLowerCase();
        bValue = getStudentPrenom(b).toLowerCase();
        break;
      case 'moyenne':
        aValue = calculerMoyenne(a);
        bValue = calculerMoyenne(b);
        break;
      case 'classement':
        const classementA = getClassementEleve(a, listEleves);
        const classementB = getClassementEleve(b, listEleves);
        aValue = classementA ? classementA.rang : 999;
        bValue = classementB ? classementB.rang : 999;
        break;
      default:
        return 0;
    }
    
    if (sortConfig.direction === 'asc') {
      return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
    } else {
      return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
    }
  });
  

  // VUE CARDS / 
 
    if(!selectedEleveId){
      return (

          <div className=" px-4 mt-5 max-w-full backdrop-blur-sm rounded-2xl shadow-xl">
              <div className="bg-gradient-to-b from-white to-sky-50 rounded-b-2xl">

            {/* ═══ HEADER gradient + blobs animés (style DetailEleve) ═══ */}
            {(() => {
              const classLevel = classeNom?.charAt(0);
              const colorSchemes = {
                '6': { gradient: 'from-blue-600 via-cyan-500 to-sky-400', blob1: '#67e8f9', blob2: '#a5f3fc' },
                '5': { gradient: 'from-purple-600 via-violet-500 to-purple-400', blob1: '#c084fc', blob2: '#e9d5ff' },
                '4': { gradient: 'from-emerald-600 via-green-500 to-emerald-400', blob1: '#34d399', blob2: '#a7f3d0' },
                '3': { gradient: 'from-rose-600 via-pink-500 to-rose-400', blob1: '#fb7185', blob2: '#fecdd3' },
              };
              const colors = colorSchemes[classLevel] || colorSchemes['6'];

              return (
                <div className="relative overflow-hidden rounded-t-2xl">
                  {/* Glow */}
                  <div className={`absolute -inset-2 bg-gradient-to-r ${colors.gradient} rounded-3xl blur-2xl opacity-30 animate-pulse`} />

                  <div className="relative overflow-hidden">
                    {/* Background gradient */}
                    <div className={`absolute inset-0 bg-gradient-to-br ${colors.gradient}`} />

                    {/* Animated liquid blobs */}
                    <svg className="absolute inset-0 w-full h-full" viewBox="0 0 800 200" preserveAspectRatio="none">
                      <defs>
                        <linearGradient id="elv-blob1" x1="0%" y1="0%" x2="100%" y2="100%">
                          <stop offset="0%" stopColor={colors.blob1} stopOpacity="0.5" />
                          <stop offset="100%" stopColor={colors.blob2} stopOpacity="0.2" />
                        </linearGradient>
                        <linearGradient id="elv-blob2" x1="0%" y1="0%" x2="100%" y2="100%">
                          <stop offset="0%" stopColor={colors.blob2} stopOpacity="0.4" />
                          <stop offset="100%" stopColor={colors.blob1} stopOpacity="0.1" />
                        </linearGradient>
                      </defs>
                      <path fill="url(#elv-blob1)">
                        <animate attributeName="d" dur="8s" repeatCount="indefinite"
                          values="M0,100 Q200,40 400,80 Q600,130 800,70 L800,200 L0,200 Z;
                                  M0,70 Q200,110 400,50 Q600,80 800,120 L800,200 L0,200 Z;
                                  M0,100 Q200,40 400,80 Q600,130 800,70 L800,200 L0,200 Z" />
                      </path>
                      <path fill="url(#elv-blob2)">
                        <animate attributeName="d" dur="6s" repeatCount="indefinite"
                          values="M0,130 Q300,80 500,110 Q700,140 800,90 L800,200 L0,200 Z;
                                  M0,90 Q300,130 500,80 Q700,100 800,140 L800,200 L0,200 Z;
                                  M0,130 Q300,80 500,110 Q700,140 800,90 L800,200 L0,200 Z" />
                      </path>
                      <circle cx="150" cy="80" r="3" fill="white" opacity="0.4">
                        <animate attributeName="cy" dur="3s" values="80;50;80" repeatCount="indefinite" />
                      </circle>
                      <circle cx="650" cy="100" r="2.5" fill="white" opacity="0.3">
                        <animate attributeName="cy" dur="4s" values="100;60;100" repeatCount="indefinite" />
                      </circle>
                      <circle cx="400" cy="70" r="3" fill="white" opacity="0.35">
                        <animate attributeName="cy" dur="3.5s" values="70;40;70" repeatCount="indefinite" />
                      </circle>
                    </svg>

                    {/* Contenu */}
                    <div className="relative px-4 sm:px-6 md:px-8 py-5 sm:py-6">
                      <div className="flex items-center justify-between gap-4 flex-wrap">
                        {/* Gauche : Titre + Boutons */}
                        <div>
                          <p className="text-[10px] text-white uppercase tracking-widest font-semibold">
                            Gestion des élèves
                          </p>
                          <h1 className="text-lg sm:text-xl font-extrabold text-white tracking-tight leading-tight">
                            Élèves
                          </h1>
                          <p className="text-xs text-white/80 mb-3">
                            {classeNom ? "Classe de " + classeNom : "Groupe " + groupNom}
                          </p>
                          {/* Boutons sous le titre — GÉNÉRER ID masqué en GAR
                              (connexion par l'ENT, pas d'identifiants TanoEd) */}
                          <div className="flex gap-2">
                            {estGar ? null : !showGenerate ? (
                              <button
                                onClick={() => setShowGenerate(true)}
                                className="bg-white/15 hover:bg-white/25 backdrop-blur-md border border-white/20
                                  px-3 py-1.5 rounded-lg font-medium text-white
                                  transition-all text-[11px] sm:text-xs duration-200 hover:-translate-y-0.5"
                              >
                                GÉNÉRER ID
                              </button>
                            ) : (
                              <GenererIdButton setShowGenerate={setShowGenerate} />
                            )}
                            {groupNom ? (
                              <button
                                onClick={() => setShowModal(true)}
                                className="bg-white/15 hover:bg-white/25 backdrop-blur-md border border-white/20
                                  px-3 py-1.5 rounded-lg font-medium text-white
                                  transition-all text-[11px] sm:text-xs duration-200 hover:-translate-y-0.5"
                              >
                                + AJOUTER ÉLÈVES
                              </button>
                            ) : null}
                          </div>
                          <p className="text-[15px] text-white/80 mt-2">Cliquez sur un élève pour voir le détail</p>
                        </div>

                        {/* Droite : Stats compactes */}
                        <div className="flex gap-2.5">
                          <div className="bg-white/15 backdrop-blur-md rounded-xl border border-white/20 px-4 py-2.5
                            hover:bg-white/20 transition-all duration-300 text-center min-w-[80px]">
                            <p className="text-[9px] text-white uppercase tracking-wider font-semibold mb-1">Élèves</p>
                            <p className="text-xl sm:text-2xl font-extrabold text-white leading-none" style={{ fontFamily: "monospace" }}>
                              {eleves?.eleves?.length || '-'}
                            </p>
                          </div>
                          <div className="bg-white/15 backdrop-blur-md rounded-xl border border-white/20 px-4 py-2.5
                            hover:bg-white/20 transition-all duration-300 text-center min-w-[80px]">
                            <p className="text-[9px] text-white uppercase tracking-wider font-semibold mb-1">Moyenne</p>
                            <p className="text-xl sm:text-2xl font-extrabold text-white leading-none" style={{ fontFamily: "monospace" }}>
                              {getMoyenneClasse(listEleves) || '-'}
                            </p>
                          </div>
                          <div className="bg-white/15 backdrop-blur-md rounded-xl border border-white/20 px-4 py-2.5
                            hover:bg-white/20 transition-all duration-300 text-center min-w-[80px]">
                            <p className="text-[9px] text-white uppercase tracking-wider font-semibold mb-1">Évaluations</p>
                            <p className="text-xl sm:text-2xl font-extrabold text-white leading-none" style={{ fontFamily: "monospace" }}>
                              {getNombreEvaluationsUniques(listEleves) || '-'}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* ═══ ONGLETS Vue Cartes / Vue Tableau ═══ */}
                  {!isMobile && (
                    <div className={`relative bg-gradient-to-br ${colors.gradient}`}>
                      <div className="absolute inset-0 bg-black/5" />
                      <div className="relative flex items-center gap-0.5 px-4 sm:px-6 overflow-x-auto">
                        {[
                          { key: 'cards', label: 'Vue Cartes', icon: '📊' },
                          { key: 'table', label: 'Vue Tableau', icon: '📋' },
                        ].map(tab => (
                          <button
                            key={tab.key}
                            onClick={() => setCurrentView(tab.key)}
                            className={`elv-btn relative px-3 sm:px-5 py-2 sm:py-2.5 text-[11px] sm:text-xs font-medium
                              transition-all duration-200 whitespace-nowrap flex items-center gap-1.5 ${
                              currentView === tab.key
                                ? 'elv-active text-white/90 bg-white/8'
                                : 'text-white/35 hover:text-white/60'
                            }`}
                          >
                            <span>{tab.icon}</span>
                            <span>{tab.label}</span>
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              );
            })()}

            {/* CSS for tab underline + card hover + responsive vars */}
            <style>{`
              .elv-btn { position: relative; cursor: pointer; }
              .elv-btn::after {
                content: ''; position: absolute; bottom: 0; left: 50%; width: 0; height: 2.5px;
                background: rgba(255,255,255,0.7); border-radius: 2px;
                transition: all 0.2s ease; transform: translateX(-50%);
              }
              .elv-active::after { width: 70%; }

              .elv-card { transition: all 0.3s cubic-bezier(.4,0,.2,1); position: relative; z-index: 1; }
              .elv-card:hover { transform: translateY(-5px); z-index: 10;
                box-shadow: 0 20px 56px rgba(30,58,138,0.14), 0 8px 20px rgba(30,58,138,0.08), inset 0 1px 0 rgba(255,255,255,0.95) !important;
              }

              .elv-cards-area {
                --elv-r: 18px; --elv-pad: 20px 22px;
                --elv-avatar: 42px; --elv-avatar-fs: 15px;
                --elv-name: 14px; --elv-meta: 11px;
                --elv-stat: 18px; --elv-stat-sub: 10px;
                --elv-bar: 6px; --elv-dot: 7px; --elv-leg: 10px;
                --elv-rank: 12px;
              }
              @media (min-width:1280px) and (max-width:1699px) {
                .elv-cards-area {
                  --elv-r: 14px; --elv-pad: 14px 16px;
                  --elv-avatar: 36px; --elv-avatar-fs: 13px;
                  --elv-name: 12px; --elv-meta: 10px;
                  --elv-stat: 15px; --elv-stat-sub: 9px;
                  --elv-bar: 5px; --elv-dot: 6px; --elv-leg: 9px;
                  --elv-rank: 11px;
                }
              }
              @media (min-width:1700px) and (max-width:1919px) {
                .elv-cards-area {
                  --elv-r: 16px; --elv-pad: 16px 18px;
                  --elv-avatar: 38px; --elv-avatar-fs: 14px;
                  --elv-name: 13px; --elv-meta: 10px;
                  --elv-stat: 16px; --elv-stat-sub: 9px;
                  --elv-bar: 5px; --elv-dot: 6px; --elv-leg: 9px;
                  --elv-rank: 11px;
                }
              }
            `}</style>

            {/* ═══ Barre de filtres glassmorphism ═══ */}
            <div className="mx-4 sm:mx-6 mt-4 p-3 rounded-xl flex flex-col sm:flex-row items-center gap-3"
              style={{
                background: 'linear-gradient(180deg, rgba(255,255,255,0.92) 0%, rgba(248,250,252,0.88) 100%)',
                backdropFilter: 'blur(8px)',
                boxShadow: '0 1px 3px rgba(0,0,0,0.06), 0 0 0 1px rgba(0,0,0,0.04)',
              }}>
              {/* Recherche avec icône */}
              <BarreRecherche
                value={searchTerm}
                onChange={setSearchTerm}
                placeholder="Rechercher un élève..."
                className="flex-1 w-full sm:w-auto"
              />
              {/* Selects filtres */}
              <div className="flex gap-2 w-full sm:w-auto">
                <SelectFiltre
                  label="Groupe"
                  value={selectedGroup === 'all' ? 'Tous groupes' : selectedGroup}
                  options={[{ value: 'all', label: 'Tous groupes' }, ...uniqueGroups.map((gp) => ({ value: gp, label: gp }))]}
                  onChange={setSelectedGroup}
                />
                <SelectFiltre
                  label="Moyenne"
                  value={(MOYENNE_OPTIONS.find((o) => o.value === selectedAverage) || MOYENNE_OPTIONS[0]).label}
                  options={MOYENNE_OPTIONS}
                  onChange={setSelectedAverage}
                />
              </div>
            </div>


            {/* Message Post - Responsive */}
            {messagePost && (
              <div className="mx-4 sm:mx-6 lg:mx-8 mb-4 bg-green-50 border border-green-200 rounded-lg p-3 sm:p-4 flex items-center gap-2 sm:gap-3">
                <div className="w-6 h-6 sm:w-8 sm:h-8 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white text-xs sm:text-sm">ℹ</span>
                </div>
                <p className="text-green-800 font-medium text-xs sm:text-sm xl:text-xs 2xl:text-sm 3xl:text-base">{messagePost}</p>
              </div>
            )}

            {/* TABLE VIEW - Caché sur mobile/tablette */}
            {!isMobile && currentView === 'table' && (
              <div ref={divRef} className="mt-5 justify-center overflow-y-auto max-h-[60vh] px-6 rounded-3xl shadow-2xl shadow-slate-400">
                <table className="min-w-full">
                  <thead className="bg-gradient-to-r from-blue-500 to-sky-600 text-white">
                    <tr>
                      <th 
                        className="p-4 text-left text-xs font-semibold uppercase tracking-wider cursor-pointer hover:bg-white/10 transition-colors"
                        onClick={() => handleSort('nom')}
                      >
                        <div className="flex items-center gap-2">
                          NOM
                          {sortConfig.key === 'nom' && (
                            <span>{sortConfig.direction === 'asc' ? '▲' : '▼'}</span>
                          )}
                        </div>
                      </th>
                      
                      <th 
                        className="p-4 text-left text-xs font-semibold uppercase tracking-wider cursor-pointer hover:bg-white/10 transition-colors"
                        onClick={() => handleSort('prenom')}
                      >
                        <div className="flex items-center gap-2">
                          Prénom
                          {sortConfig.key === 'prenom' && (
                            <span>{sortConfig.direction === 'asc' ? '▲' : '▼'}</span>
                          )}
                        </div>
                      </th>
                      
                      {(classeNom[0] === '6' || classeNom[0] === '5') && 
                        <th className="p-4 text-left text-xs font-semibold uppercase tracking-wider">
                          Groupe actuel
                        </th>
                      }
                      
                      {groupNom && 
                        <th className="p-4 text-left text-xs font-semibold uppercase tracking-wider">
                          Classe d'origine
                        </th>
                      }
                      
                      <th 
                        className="p-4 text-left text-xs font-semibold uppercase tracking-wider cursor-pointer hover:bg-white/10 transition-colors"
                        onClick={() => handleSort('moyenne')}
                      >
                        <div className="flex items-center gap-2">
                          Moyenne des compétences
                          {sortConfig.key === 'moyenne' && (
                            <span>{sortConfig.direction === 'asc' ? '▲' : '▼'}</span>
                          )}
                        </div>
                      </th>
                      
                      <th className="p-4 text-left text-xs font-semibold uppercase tracking-wider">
                        Évaluations
                      </th>
                      
                      <th className="p-4 text-left text-xs font-semibold uppercase tracking-wider">
                        Compétences {groupNom ? "dans le groupe" : "dans la classe"}
                      </th>
                      
                      <th 
                        className="p-4 text-left text-xs font-semibold uppercase tracking-wider cursor-pointer hover:bg-white/10 transition-colors"
                        onClick={() => handleSort('classement')}
                      >
                        <div className="flex items-center gap-2">
                          POSITION
                          {sortConfig.key === 'classement' && (
                            <span>{sortConfig.direction === 'asc' ? '▲' : '▼'}</span>
                          )}
                        </div>
                      </th>
                      
                      <th className="p-4 text-left text-xs font-semibold uppercase tracking-wider">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {filteredStudents && filteredStudents.map((eleve) => (
                      <TableRowEleve
                        key={eleve.id}
                        eleve={eleve}
                        getClassementEleve={getClassementEleve}
                        listEleves={listEleves}
                        handleRowClick={handleRowClick}
                        resultats={resultats}
                        getPositionIcon={getPositionIcon}
                        calculerMoyenne={calculerMoyenne}
                        getNbEval={getNbEval}
                        classeNom={classeNom}
                        groupNom={groupNom}
                        handleMessagePost={handleMessagePost}
                        setListEleves={setListEleves}
                        handleReload={handleReload}
                      />
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* Cards View - Toujours visible sur mobile, optionnel sur desktop */}
            {(isMobile || currentView === 'cards') && (
              <div className="elv-cards-area px-4 sm:px-6 py-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-3 sm:gap-5 xl:gap-3 2xl:gap-4 3xl:gap-5
                  pr-2">
                  {filteredStudents.map(student => (
                    <StudentCard
                      key={student.id}
                      student={student}
                      getClassementEleve={getClassementEleve}
                      listEleves={listEleves}
                      getInitials={getInitials}
                      getNbEval={getNbEval}
                      calculerMoyenne={calculerMoyenne}
                      resultats={resultats}
                      getPositionIcon={getPositionIcon}
                      handleRowClick={handleRowClick}
                    />
                  ))}
                </div>
              </div>
            )}

            {showModal && groupNom && !classeNom && (
            <AddElevesToGroup
              show={showModal}
              handleClose={handleClose}
              groupNom={groupNom}
              classeDate="2024-2025"
              handleAddEleveToGroup={handleAddEleveToGroup}
              handleMessagePost={handleMessagePost}
              handleReload={handleReload}
            />
          )}

          </div>
          </div>
      );
    }

    return(
      <FicheEleve
        selectedEleveId={selectedEleveId}
        listEleves={listEleves}
        classeDetail={eleves}
        resultats={resultats}
        handleRowClick={handleRowClick}
        getClassementEleve={getClassementEleve}
        calculerMoyenne={calculerMoyenne}
        getNbEval={getNbEval}
      />
    );
}

export default Eleve;

// Composant GenererIdButton
const GenererIdButton = ({setShowGenerate}) => {
  const {idclasse} = useParams();
  const {data: listMdp, isLoading : isLoadingEleve} = useEleve(`generer_identifiants_mdp/?classe_id=${idclasse}`);

  const handleGeneratePassWordEleve = async () => {
    // Préparer les données pour l'exportation
    const data = [];

    // En-tête du tableau
    const headers = ['Classe', 'Nom', 'Prénom', 'Identifiant', 'Mot de Passe'];
    data.push(headers);

    // Lignes des résultats des élèves
    listMdp.forEach(eleve => {
        const row = [eleve.classe, eleve.nom, eleve.prenom, eleve.identifiant, eleve.mot_de_passe];
        data.push(row);
    });

    // Créer une feuille de calcul
    const worksheet = XLSX.utils.aoa_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Identifiants et Mots de Passe');

    // Exporter le fichier Excel
    XLSX.writeFile(workbook, 'identifiants_mots_de_passe.xlsx');
    setShowGenerate(false)
  }
  
  if(isLoadingEleve){
    return <Loading loadingText={"Chargement des id et mdp d'élèves..."} /> 
  }
  
  return (
    <button  
      onClick={handleGeneratePassWordEleve}
      className="bg-white/20 hover:bg-white/30 backdrop-blur-sm border
        border-white/30 px-3 sm:px-6 py-2 sm:py-3 rounded-lg font-medium 
        transition-all text-xs sm:text-sm lg:text-lg duration-200 hover:-translate-y-0.5"
    >
      Exporter .csv
    </button>
  );
};